import type { NavItem } from "./nav";

/**
 * The top level of the information architecture, in one place so the real
 * chrome and the demo cannot drift apart. A plain module, no JSX and no data
 * path, so anything may read it.
 *
 * Three sections each, and nothing else, with one ruled exception: the
 * Consumer's My care (H55). Everything a person configures rather than works in
 * lives inside Settings, which is what keeps the bar legible on a phone and the
 * drawer short.
 */

/**
 * Customer: find something, track what you booked, read what your clinics
 * prepared for you, manage your account.
 *
 * My care is the fourth because it is a place you return to rather than a
 * setting: a meal plan is read every day it is current (H55), and a link to it
 * buried in Settings or on the bookings screen was a link nobody found.
 */
export const CONSUMER_NAV: NavItem[] = [
  { href: "/search", label: "Search", icon: "search" },
  { href: "/bookings", label: "Bookings", icon: "bookings" },
  { href: "/care", label: "My care", icon: "care" },
  { href: "/profile", label: "Settings", icon: "settings" },
];

/**
 * Business: Schedule is what is happening (and carries the requests awaiting a
 * decision, since deciding is daily work); Dashboard is who the customers are;
 * Settings holds Team, Services, opening hours, and the public profile.
 */
export const BUSINESS_NAV: NavItem[] = [
  { href: "/business", label: "Schedule", icon: "schedule" },
  { href: "/business/insights", label: "Dashboard", icon: "dashboard" },
  { href: "/business/settings", label: "Settings", icon: "settings" },
];

/**
 * Admin: the queue of businesses waiting to be let in, and the platform view.
 *
 * The admin area previously mounted the *business* navigation, so an admin was
 * offered Schedule, Dashboard and Settings, all pointing at /business routes
 * their role cannot open. Two honest sections beat three broken ones.
 */
export const ADMIN_NAV: NavItem[] = [
  { href: "/admin", label: "Registrations", icon: "queue" },
  { href: "/admin/insights", label: "Platform", icon: "dashboard" },
];
